import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useUserStore } from "../../hooks/userHooks/user.hooks";
import { getValue } from "../../utils/object.utils";
import { isUserRoleValidForNavigation } from "../../roleConfig";
import { Paths } from "../../Constants/paths";

export const AuthenticationRoute = () => {
  const { user } = useUserStore();

  const userRole = getValue(user, "role", "");

  const location = useLocation();
  const path = getValue(location, "pathname");

  const isRolePermitted = isUserRoleValidForNavigation({ path, userRole });

  // if (!isRolePermitted) {
  //   return <Navigate to={Paths.Dashboard} replace />;
  // }

  return <Outlet />;
};
